import { QualityControlItem } from './item';
import { AssemblyItem } from '../../../api/elite/types/assembly-item';
import { Inspection } from '../../../api/elite/types/inspections';
import { SubWorkOrder } from '../../../api/elite/types/sub-work-order';
import { SchedulerWorkOrder } from '../../scheduler/models/work-order';

export class QualityControlWorkOrder
  extends SchedulerWorkOrder
  implements QualityControlItem
{
  assemblyItem: AssemblyItem;
  quantityRequired: number;
  quantityBuilt: number;
  builtReport: number;
  quantityPacked: number;

  quantityAvailable = 0; // virtual, this is the quantity on the subwork order for the stage after cycles

  currentInspection: Inspection = undefined;

  get measurementsMade(): number {
    return this.currentInspection?.measureRecords?.length || 0;
  }

  get labTestsToDo(): { id: number; title: string }[] {
    return this.currentInspection?.testRecords?.map((el) => el.testType);
  }

  get itemIdForInspection(): number {
    return this.workOrderId;
  }

  get quantityOnQc(): number {
    return this.qcSubWorkOrder?.quantity;
  }
  set quantityOnQc(val: number) {
    if (this.qcSubWorkOrder) {
      this.qcSubWorkOrder.quantity = val;
    }
  }

  qcSubWorkOrder: SubWorkOrder | undefined;
  subWorkOrders: SubWorkOrder[] = [];

  get producedPlusOnValidation(): number {
    return this.builtReport + this.quantityPacked;
  }

  get quantityToDo(): number {
    const val = this.quantityRequired - this.producedPlusOnValidation;
    return val > 0 ? val : 0;
  }

  get assemblyTitle(): string {
    return this.assemblyItem.title;
  }

  get assemblyType(): string {
    if (
      !this.assemblyItem?.typesList ||
      this.assemblyItem?.typesList?.length === 0
    ) {
      return '';
    }
    return this.assemblyItem?.typesList[0]?.title || '';
  }

  static fromObject(obj: SchedulerWorkOrder): QualityControlWorkOrder {
    const newObj = new QualityControlWorkOrder();
    Object.assign(newObj, obj);
    return newObj;
  }

  compareItemName(itemName: string): boolean {
    return (
      this.assemblyItem.title === itemName
      // || this.assemblyItem.title.startsWith(itemName)
    );
  }
}
